<template>
    <div>
      <div v-if="recommendList && recommendList.length">
        <div v-for="(sectionInfo) in recommendList" :key="$route.fullPath + sectionInfo.title" class="multi-section-container">
            <DynamicSectionLoader :section-info="sectionInfo" bottom-tab="recommend"/>
        </div>
      </div>
      <div v-if="Array.isArray(recommendList) && recommendList.length === 0" class="recommend-empty">
        <empty />
        <p>추천 콘텐츠가 없어요.</p>
      </div>
    </div>
</template>
<script>
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import { get } from 'lodash'
import MultiSectionModel from '@/common/model/MultiSectionModel'
import Empty from '@/assets/svg/common/img-empty.svg'
import { mapMutations } from 'vuex'
import { BottomTabService } from '@/common/api/api.service'
export default {
  name: 'RecommendContentList',
  components: {
    DynamicSectionLoader,
    Empty
  },
  props: { contentInfo: { type: Object }, section: { type: String } },
  data () {
    return {
      recommendList: null
    }
  },
  methods: {
    ...mapMutations(['showLoadingProgress', 'hideLoadingProgress']),
    setData () {
      this.showLoadingProgress()
      const callApiFunction = BottomTabService.getRecommendMultiSectionListApi(this.section)
      callApiFunction({
        movieID: this.contentInfo.movieid,
        contentID: this.contentInfo.contentid,
        programID: this.contentInfo.programid,
        channelID: this.contentInfo.channelid,
        clipID: this.contentInfo.clipid
      }).then(({ data }) => {
        this.recommendList = get(data, 'multisectionlist', []).map((multiSection, index) => {
          return new MultiSectionModel(multiSection)
        })
        this.hideLoadingProgress()
      })
    }
  },
  created () {
    this.setData()
  }
}
</script>
<style>
  .recommend-empty{
    padding: 60px 0;
    text-align: center;
  }
  .recommend-empty p{
    margin-top: 13px;
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }
</style>
